/* global _OPTIMIZELY_SDK_KEY */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createInstance, OptimizelyProvider } from '@optimizely/react-sdk';
import { currentUserIdSelector } from '../../ReduxStorage/Auth/selectors';

export const optimizely = createInstance({
  sdkKey: _OPTIMIZELY_SDK_KEY,
  datafileOptions: {
    autoUpdate: true,
    updateInterval: 300000, // 5 minutes in milliseconds
  },
});

const _OptimizelyProvider = ({ userId, children }) => (
  <OptimizelyProvider
    optimizely={optimizely}
    user={{ id: userId || 'anonymous' }}
  >
    {children}
  </OptimizelyProvider>
);
_OptimizelyProvider.propTypes = {
  userId: PropTypes.string,
  children: PropTypes.node,
};
_OptimizelyProvider.defaultProps = {
  userId: null,
  children: null,
};

function mapStateToProps(state) {
  return {
    userId: currentUserIdSelector(state),
  };
}

export const ConnectedOptimizelyProvider = connect(mapStateToProps)(
  _OptimizelyProvider
);

export { ConnectedOptimizelyProvider as OptimizelyProvider };
